// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"60192fcd","109":"b8175e03","249":"efac73a2","294":"969f7bc4","478":"95628085","524":"4d09ee05","706":"9ead0077","748":"2426baf1","780":"a3371589","926":"338b733c","971":"fe9e18d9"}[chunkId] + ".chunk.js";
};